// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__LAbuu","header":"Messages_header__1uua2"};